import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  const [action, setAction] = useState("");
  const load = () => api.get(`/admin/audit-logs${action ? `?action=${action}` : ""}`).then((r) => setLogs(r.data));
  useEffect(() => { load(); }, [action]);
  const actions = [...new Set(logs.map((l) => l.action))];
  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between flex-wrap gap-3"><h1 className="text-2xl font-bold">Audit Logs</h1>
        <select data-testid="audit-filter" value={action} onChange={(e) => setAction(e.target.value)} className="px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm"><option value="">All actions</option>{actions.map((a) => <option key={a} value={a}>{a}</option>)}</select></div>
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]"><thead><tr className="text-xs font-bold uppercase text-slate-500 bg-slate-50">
          <th className="text-left py-3 px-4">Time</th><th className="text-left py-3 px-4">User</th><th className="text-left py-3 px-4">Role</th><th className="text-left py-3 px-4">Action</th><th className="text-left py-3 px-4">Entity</th><th className="text-left py-3 px-4">Platform</th></tr></thead>
          <tbody>{logs.map((l) => (
            <tr key={l.id} data-testid={`audit-${l.id}`} className="border-b border-slate-50 hover:bg-slate-50">
              <td className="py-2.5 px-4 text-slate-500 whitespace-nowrap">{new Date(l.timestamp).toLocaleString("en-IN")}</td>
              <td className="py-2.5 px-4">{l.user_email || "system"}</td>
              <td className="py-2.5 px-4"><span className="text-xs font-bold text-slate-600">{l.role}</span></td>
              <td className="py-2.5 px-4"><span className="text-xs font-bold px-2 py-0.5 rounded bg-slate-100">{l.action}</span></td>
              <td className="py-2.5 px-4 text-slate-500">{l.collection} · {l.record_id?.slice(-8)}</td>
              <td className="py-2.5 px-4"><span className="text-xs uppercase text-slate-400">{l.platform}</span></td>
            </tr>
          ))}
          {!logs.length && <tr><td colSpan="6" className="text-center py-10 text-slate-400">No audit logs</td></tr>}</tbody>
        </table>
      </div>
    </div>
  );
}
